export function continuationUrl(href: string): string {
  const current = new URL(href);
  const demo = current.pathname === "/" || /^\/demo(?:\/|$)/.test(current.pathname);
  // An entry link must never carry an OAuth response or classroom-specific parameters.
  return new URL(demo ? "/demo" : "/app", current.origin).href;
}
